module.exports = __webpack_public_path__ + "static/media/jp-share-image.9198ab70.jpg";